import T from "../theme/colors";

export default function StatusTabs({ tabs, active, onSelect, counts = {} }) {
  return (
    <div style={{ display: "flex", gap: 4, marginBottom: 16, flexWrap: "wrap", borderBottom: `1px solid var(--border)`, paddingBottom: 0 }}>
      {tabs.map(tab => {
        const isActive = active === tab;
        return (
          <button
            key={tab}
            onClick={() => onSelect(tab)}
            style={{
              background: "transparent",
              border: "none",
              borderBottom: `2px solid ${isActive ? "var(--primary)" : "transparent"}`,
              color: isActive ? "var(--primary)" : "var(--text-1)",
              padding: "8px 14px 10px",
              fontSize: 14, fontWeight: isActive ? 600 : 400,
              cursor: "pointer", transition: "all 0.15s",
              letterSpacing: "0.02em",
              fontFamily: "var(--font-ui)",
              display: "flex", alignItems: "center", gap: 6,
            }}
          >
            {tab.replace(/_/g, " ")}
            {counts[tab] !== undefined && (
              <span style={{
                background: isActive ? "var(--primary-dim)" : "var(--border)",
                color: isActive ? "var(--primary)" : "var(--text-2)",
                padding: "1px 6px", borderRadius: 20,
                fontSize: 12, fontWeight: 600,
              }}>
                {counts[tab]}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
